import { useTheme } from '@mui/material';

export const usePositionCellStyles = () => {
  const theme = useTheme();

  return {
    dataCell: {
      verticalAlign: 'top !important',
    },
    text: {
      paddingTop: theme.spacing(1.25),
    },
  };
};
